import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom'

import circleLanContents from '../CircleLan/contents.json'
import './ComicsDisplay.css'
import {SEO} from "../../../components/SEO";

interface IComicsDisplay {
    match: {
        params: {
            comic: string,
            section: string,
            chapter: string
        }
    }
}

function ComicsDisplay({match}: IComicsDisplay) {
    const {comic, section, chapter} = match.params;
    const [contents, setContents] = useState([])
    const [content, setContent] = useState([])
    const [layout, setLayout] = useState('')

    useEffect(() => {
        if (comic === 'circle-lan') { // @ts-ignore
            setContents(circleLanContents)
        }
    }, [comic])

    useEffect(() => {
        if (section === 'キャラ紹介') setLayout('items-center flex-wrap')
        else if (chapter === '作者から一言') setLayout('flex-col items-start')
        else setLayout('flex-col items-center flex-wrap')
    }, [section, chapter])

    useEffect(() => {
        for (let i = 0; i < contents.length; i++) {
            // @ts-ignore
            if (contents[i][section] === undefined) continue
            // @ts-ignore
            for (let j = 0; j < contents[i][section].length; j++) {
                if (contents[i][section][j][chapter] === undefined) continue
                setContent(contents[i][section][j][chapter])
            }
        }
    }, [contents, section, chapter])

    return (
        <>
            {
                Object.keys(content).length === 0 ? (
                    <svg className="animate-spin -ml-1 mr-3 h-10 w-10 text-yellow-400 w-full"
                         xmlns="http://www.w3.org/2000/svg"
                         fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                ) : (
                    <div className={`flex justify-center ${layout}`}>
                        {
                            content.map(element => {
                                if (element['type'] === 'text') {
                                    return <p key={element['content']} className={'my-4'}>{element['content']}</p>
                                } else if (element['type'] === 'chara') {
                                    return <img key={element['content']}
                                                alt="キャラ紹介"
                                                src={`/comics/${comic}/${element['content']}`}
                                                className="w-5/12 lg:w-3/12"
                                            />
                                } else if (element['type'] === 'koma-full') {
                                    return <img key={element['content']}
                                                alt="コマ"
                                                src={`/comics/${comic}/${element['content']}`}
                                                className="w-full"
                                            />
                                } else if (element['type'] === 'koma') {
                                    return <img key={element['content']}
                                                alt="コマ"
                                                src={`/comics/${comic}/${element['content']}`}
                                                className="w-96"
                                            />
                                } else if (element['type'] === 'next') {
                                    return (
                                        <Link to={`/comics/circle-lan/${encodeURI(element['content'])}`}
                                              className={'mt-4 py-2 px-4 text-white bg-yellow-500 rounded-xl'}
                                        >
                                            Next
                                        </Link>
                                    )
                                } else if (element['type'] === 'youtube-large') {
                                    return (
                                        <div className="comics_display__vic_container">
                                            <iframe src={element['content']}
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen />
                                        </div>
                                    )
                                } else if (element['type'] === 'back') {
                                    return (
                                        <Link to={`/comics/circle-lan`}
                                              className={'mt-4 py-2 px-4 text-white bg-yellow-500 rounded-xl'}
                                        >
                                            Back
                                        </Link>
                                    )
                                } else if (element['type'] === 'thumbnail') {
                                    return <SEO isDefault={false} title={`${comic} ${chapter}`} description={chapter} image={element['content']} />
                                }
                            })
                        }
                    </div>
                )
            }
        </>
    );
}

export default ComicsDisplay;